import { render, staticRenderFns } from "./BookNowNew.vue?vue&type=template&id=d12f0d92&"
import script from "./BookNowNew.vue?vue&type=script&lang=js&"
export * from "./BookNowNew.vue?vue&type=script&lang=js&"
import style0 from "./BookNowNew.vue?vue&type=style&index=0&id=d12f0d92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIDiacritics: require('/opt/build/repo/components/UI/Diacritics.vue').default,CoursesPurchaseButtonNew: require('/opt/build/repo/components/Courses/PurchaseButtonNew.vue').default,UIClearPay: require('/opt/build/repo/components/UI/ClearPay.vue').default,CartCountdownAltAuto: require('/opt/build/repo/components/Cart/CountdownAltAuto.vue').default,CoursesStickyBookBar: require('/opt/build/repo/components/Courses/StickyBookBar.vue').default})
